import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart, MapPin, Clock } from 'lucide-react';
import { Hero } from '../components/Hero';
import { FeaturedItems } from '../components/FeaturedItems';
const STOREFRONT_IMG = 'https://cdn.magicpatterns.com/uploads/eXCtDymCaaxJyyjcCGY8UZ/IMG_1811.jpg';
const TEAM_IMG = 'https://cdn.magicpatterns.com/uploads/nwaFokr74juteZS55uN5r6/IMG_1797.jpg';
const FEEP_IMG = 'https://cdn.magicpatterns.com/uploads/6Jqi6t9HeDymL6x7JQUrSp/IMG_1798.jpg';
export function Home() {
  return <div className="flex flex-col w-full" data-id="element-308">
      <Hero data-id="element-309" />
      <FeaturedItems data-id="element-310" />
      {/* Visítanos — terraza */}
      <section className="py-24 bg-cafe-bg" data-id="element-311">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-312">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="relative rounded-3xl overflow-hidden shadow-soft aspect-[4/5] order-2 md:order-1" data-id="element-313">
            <img src={STOREFRONT_IMG} alt="Terraza de Trastienda Café con clientes disfrutando del ambiente" className="w-full h-full object-cover" data-id="element-314" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="order-1 md:order-2" data-id="element-315">
            <span className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium" data-id="element-316">
              Visítanos
            </span>
            <h2 className="text-3xl md:text-5xl font-serif text-cafe-primary mt-3 mb-6 leading-tight" data-id="element-317">
              Tu rincón <span className="italic" data-id="element-318">favorito</span> del barrio
            </h2>
            <p className="text-cafe-text/80 text-lg leading-relaxed mb-6" data-id="element-319">
              Disfruta de nuestra terraza tranquila y nuestro interior acogedor.
              Un espacio pensado para que te sientas como en casa desde el
              primer momento.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-320">
              <li className="flex items-center gap-3 text-cafe-text/80" data-id="element-321">
                <MapPin size={18} className="text-cafe-accent flex-shrink-0" data-id="element-322" />
                <span data-id="element-323">Te esperamos en pleno corazón del barrio</span>
              </li>
              <li className="flex items-center gap-3 text-cafe-text/80" data-id="element-324">
                <Clock size={18} className="text-cafe-accent flex-shrink-0" data-id="element-325" />
                <span data-id="element-326">Abiertos cada día para acompañarte</span>
              </li>
            </ul>
            <Link to="/contacto" className="inline-block border-b-2 border-cafe-accent text-cafe-primary font-medium pb-1 hover:text-cafe-accent transition-colors" data-id="element-327">
              Cómo llegar
            </Link>
          </motion.div>
        </div>
      </section>
      {/* Teaser Sobre Nosotros */}
      <section className="py-24 bg-cafe-card" data-id="element-328">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-329">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-330">
            <span className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium" data-id="element-331">
              Nuestra historia
            </span>
            <h2 className="text-3xl md:text-5xl font-serif text-cafe-primary mt-3 mb-6 leading-tight" data-id="element-332">
              Un café de barrio,
              <br data-id="element-333" />
              <span className="italic" data-id="element-334">hecho con cariño</span>
            </h2>
            <p className="text-lg text-cafe-text/80 leading-relaxed mb-6" data-id="element-335">
              Desde 2021, en Trastienda Café creamos un ambiente acogedor donde
              cada visita se siente como estar en casa. Nuestra pasión son los
              crepes, las tostas y los batidos artesanos, preparados con
              dedicación para acompañar tus mejores momentos.
            </p>
            <Link to="/sobre" className="inline-block border-b-2 border-cafe-accent text-cafe-primary font-medium pb-1 hover:text-cafe-accent transition-colors" data-id="element-336">
              Conoce más sobre nosotros
            </Link>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="rounded-3xl overflow-hidden shadow-soft aspect-[4/5]" data-id="element-337">
            <img src={TEAM_IMG} alt="Equipo de Trastienda Café bajo el cartel del local" className="w-full h-full object-cover" data-id="element-338" />
          </motion.div>
        </div>
      </section>
      {/* Causa Solidaria CTA */}
      <section className="py-24 bg-cafe-primary text-white overflow-hidden" data-id="element-339">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-340">
          <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-341">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="order-2 md:order-1 relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/5] md:aspect-square border border-white/10" data-id="element-342">
              <img src={FEEP_IMG} alt="Bandera de Trastienda Café en el campo base del Everest junto a la Fundación Española de Enfermedades Priónicas" className="w-full h-full object-cover" data-id="element-343" />
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="order-1 md:order-2 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-344">
              <Heart size={48} className="text-cafe-accent mb-6" strokeWidth={1.5} data-id="element-345" />
              <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-346">
                Un café con propósito
              </h2>
              <p className="text-lg text-white/80 leading-relaxed mb-10 max-w-xl" data-id="element-347">
                Trastienda Café apoya activamente a la Fundación Española de
                Enfermedades Priónicas (FEEP). Descubre cómo puedes colaborar
                con esta importante causa.
              </p>
              <Link to="/donaciones" className="inline-flex justify-center items-center px-8 py-4 text-base font-medium rounded-full text-cafe-primary bg-white hover:bg-cafe-card transition-colors duration-200" data-id="element-348">
                Hacer una donación
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}